module.exports = "../images/kayaking-on-lake-home@2x.jpg?v=6a74224";